import Addresses from "components/addresses/Addresses";
import { CompanyEntity } from "types/Company";
import CompanyDetailsCard from "../company-details-card";
import CompanyLogoBlock from "../company-logo-block";

interface CompanyInfoTabProps {
  companyEntity: CompanyEntity;
  companyId: string;
}

export default function CompanyInfoTab({
  companyEntity,
  companyId,
}: CompanyInfoTabProps) {
  return (
    <div className="space-y-5">
      <CompanyDetailsCard company={companyEntity} />

      <CompanyLogoBlock companyId={companyId} />

      <Addresses
        addresses={companyEntity?.addresses || []}
        subjectId={companyId || ""}
        subject="company"
      />
    </div>
  );
}
